import { defineStyle } from '@chakra-ui/react';

export const defaultVariant = defineStyle({
  background: 'neutral.800',
  color: 'neutral.white',
  border: '2px solid',
  borderColor: 'neutral.black',
  _placeholder: {
    color: 'neutral.300',
  },
  '&:not([data-readonly])': {
    _hover: {
      borderColor: 'skyBlue',
      background: 'neutral.700',
      _disabled: {
        borderColor: 'neutral.black',
        background: 'neutral.800',
      },
      _invalid: {
        backgroundColor: 'red.800',
      },
    },
    _focus: {
      borderColor: 'skyBlue',
      background: 'neutral.700',
    },
    _invalid: {
      borderColor: 'red',
      backgroundColor: 'red.800',
    },
  },
  _readOnly: {
    cursor: 'default',
  },
  _disabled: {
    cursor: 'default',
  },
});
